import {combineReducers} from 'redux';
//import headerReducer from "./headerReducer.js";
import searchReducer from './searchReducer.js';
import busListingReducer from './busListingReducer';
import ticketdetailsReducer from './ticketdetailsReducer';
//import journeyDetailsReducer from "./journeyDetailsReducer";
import {RESET_STORE} from '../actions/action-types';

const appReducer = combineReducers({
  searchReducer,
  busListingReducer,
  ticketdetailsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
    // console.log("resetting...");
  }
  return appReducer(state, action);
};

export default rootReducer;
